document.addEventListener("DOMContentLoaded", function () {
    console.log("🛠️ Script FINAL: Modo de Supervivencia (Solo estado y DOM).");

    const CHILLER_CONTAINER_ID = "#option-yes";
    const NO_CHILLER_BUTTON_ID = "#option-no-button"; 
    const PROTECTION_FIELDSET_CLASS = ".custom_chooseprotection";
    const STATE_INPUT_ID = "#chillerselected";
    const CHILLER_RADIO_SELECTOR = 'input[name^="Water Chiller-1"]';

    // *** ELEMENTOS DEL SWITCH DE WI-FI ***
    const WIFI_SWITCH_CONTAINER_CLASS = '.switch-container';
    const WITHOUT_WIFI_RADIO_SELECTOR = 'input[type="radio"][value="No"]';
    // ***********************************

    // Mapeo de precios por HP
    const baseProtectionText = "5- Year";
    const priceMap = {
        "1/3HP": " +$99",
        "1/2HP": " +$149",
        "1HP": " +$199"
    };

    let isInitialLoad = true;

    // --- FUNCIÓN AUXILIAR: Obtener el elemento de la variante de protección ---
    function getProtectionVariantElement() {
        const currentProtectionFieldset = document.querySelector(PROTECTION_FIELDSET_CLASS); 
        const protectionInput = currentProtectionFieldset ? currentProtectionFieldset.querySelector('input[value*="5- Year"]') : null; 
        if (!protectionInput) return null;

        const protection5YearLabel = protectionInput.nextElementSibling;
        return protection5YearLabel ? protection5YearLabel.querySelector('.variant-name') : null;
    }

    // --- FUNCIÓN CENTRAL: UPDATE (Aplica SOLO el texto visible) ---
    function updateProtectionPrice() {
        const stateInput = document.querySelector(STATE_INPUT_ID);
        // Usamos .trim() para limpiar posibles espacios en blanco
        let selectedChillerValue = stateInput ? stateInput.value.trim() : null; 

        // ⭐ LÓGICA CLAVE DE INICIALIZACIÓN
        if (!selectedChillerValue || isInitialLoad) {
            // 1. Buscar si algún radio de HP está seleccionado
            const defaultSelectedRadio = document.querySelector(CHILLER_CONTAINER_ID + ' ' + CHILLER_RADIO_SELECTOR + ':checked');
            if (defaultSelectedRadio) {
                selectedChillerValue = defaultSelectedRadio.value;
            } 
            // 2. Si no hay valor y no hay HP seleccionado, asumimos que es "No Chiller" (El valor por defecto problemático)
            else if (!selectedChillerValue) { 
                 selectedChillerValue = "No Chiller"; 
                 console.log(`[INICIO] 🔄 Forzando estado inicial a: ${selectedChillerValue}`);
            }

            // Si encontramos un valor, actualizamos el input de estado
            if (stateInput && selectedChillerValue) {
                stateInput.value = selectedChillerValue;
            }
        }
        
        isInitialLoad = false;

        if (!selectedChillerValue) return; 

        const protection5YearVariantName = getProtectionVariantElement();
        if (!protection5YearVariantName) return;

        let priceSuffix = "";

        // Determinar el sufijo de precio
        // Se mantiene la agrupación: 1/3HP y "No Chiller" usan el mismo precio.
        if (selectedChillerValue.includes("1/3HP") || selectedChillerValue === "No Chiller") {
            priceSuffix = priceMap["1/3HP"]; // +$99
        } else if (selectedChillerValue.includes("1/2HP")) {
            priceSuffix = priceMap["1/2HP"];
        } else if (selectedChillerValue.includes("1HP")) {
            priceSuffix = priceMap["1HP"];
        } else {
            priceSuffix = "";
        }

        const newVisibleText = baseProtectionText + priceSuffix;

        // Aplicar SOLO el cambio de texto visible
        if (protection5YearVariantName.textContent.trim() !== newVisibleText.trim()) {
            protection5YearVariantName.textContent = newVisibleText;
            console.log(`✅ Precio visible actualizado a: ${newVisibleText}`);
        }
    }

    // --- NUEVA FUNCIÓN AÑADIDA: FUERZA EL SWITCH DE WI-FI A OFF ---
    /**
     * Fuerza el switch de Wi-Fi al estado "Sin Wi-Fi" (OFF) 
     * y selecciona el radio button "No".
     */
    function forceWifiSwitchOff() {
        const switchContainer = document.querySelector(WIFI_SWITCH_CONTAINER_CLASS);
        const withoutWifiInput = document.querySelector(WITHOUT_WIFI_RADIO_SELECTOR);
        
        // 1. Solo actuamos si el switch está actualmente 'is-active' (Wi-Fi ON)
        if (switchContainer && switchContainer.classList.contains('is-active')) {
            
            console.log("   🔌 Desactivando Switch de Wi-Fi.");
            
            // 2. Deseleccionar visualmente el switch
            switchContainer.classList.remove('is-active');
            
            // 3. Forzar la selección del input "No" (Sin Wi-Fi)
            if (withoutWifiInput && withoutWifiInput.checked !== true) {
                withoutWifiInput.checked = true;
                // Disparar un evento de cambio (Opcional, pero recomendado si otro código depende de él)
                withoutWifiInput.dispatchEvent(new Event('change', { bubbles: true })); 
            }
            
            // 4. Llama a la función de precios de Wi-Fi si estuviera disponible en este scope.
            // Si la función `updateChillerPrices(false)` está definida aquí, llámala:
            // if (typeof updateChillerPrices === 'function') {
            //     updateChillerPrices(false);
            // } 
            // NOTA: Si `updateChillerPrices` no está aquí, confiaremos en la lógica del switch
            // que se dispara con el 'change' del radio button "No".
        }
    }
    // -----------------------------------------------------------

    // --- FUNCIÓN DE PERSISTENCIA (Inmediata y local) ---
    function immediateUpdate() {
        // Retraso mínimo para desfasar la ejecución del thread principal
        setTimeout(updateProtectionPrice, 50); 
    }

    // ====================================================================
    // 1. LÓGICA DE CLIC (Manejo de estado y precio)
    // ====================================================================
    function handleNoChillerClick(event) {
        // CLAVE: Detenemos la propagación para que ningún otro script lo intercepte
        event.stopPropagation();
        event.preventDefault(); 

        const stateInput = document.querySelector(STATE_INPUT_ID);

        console.log("🔥 EVENTO CLICK (NO CHILLER) detectado. MÁXIMO AISLAMIENTO.");

        // 1. Actualizar el estado a "No Chiller"
        if (stateInput) {
            stateInput.value = "No Chiller";
            console.log(`   -> Input de estado actualizado a ${stateInput.value}`);
        }
        
        // 2. ⭐ SOLUCIÓN AL PROBLEMA DEL WI-FI: Forzar la desactivación
        forceWifiSwitchOff();

        // 3. Aplicar el precio de la garantía inmediatamente
        immediateUpdate(); 
    }

    // Maneja los cambios de los radio buttons de HP
    document.addEventListener("change", function(event) {
        if (event.target.matches(CHILLER_CONTAINER_ID + ' ' + CHILLER_RADIO_SELECTOR)) {
            const stateInput = document.querySelector(STATE_INPUT_ID);

            if (stateInput) stateInput.value = event.target.value;
            
            // Opcional: Si seleccionamos un Chiller de HP, el switch debería estar encendido
            // o permitir que el usuario lo encienda, por lo que no lo forzamos a OFF aquí.

            immediateUpdate(); 
        }
    });

    // ====================================================================
    // 2. HACK: BUCLE DE RE-ADJUNCIÓN (Para manejo de carga dinámica)
    // ====================================================================
    const CUSTOM_LISTENER_ATTR = 'data-custom-chiller-listener';

    setInterval(() => {
        const noButton = document.querySelector(NO_CHILLER_BUTTON_ID);

        if (noButton && !noButton.hasAttribute(CUSTOM_LISTENER_ATTR)) {

            // Adjuntar nuestro handler
            noButton.addEventListener('click', handleNoChillerClick);
            noButton.setAttribute(CUSTOM_LISTENER_ATTR, 'true');

            console.log("HACK: Reiniciando listener de 'No Chiller'");

            // Adjuntar al padre (para capturar si la clonación afecta solo al botón interno)
            const parentGroup = noButton.closest('.product-form__input-chiller-group');
            if(parentGroup) {
                parentGroup.addEventListener('click', function(event) {
                    if (event.target.closest(NO_CHILLER_BUTTON_ID)) {
                        handleNoChillerClick(event);
                    }
                });
            }
        }
    }, 200); 

    // ====================================================================
    // 3. Llamada inicial (Doble chequeo para manejo asíncrono)
    // ====================================================================
    setTimeout(() => {
        console.log("🚀 Iniciando aplicación inicial.");
        updateProtectionPrice(); 
        immediateUpdate();
    }, 400); 
});